import { render, staticRenderFns } from "./BillTotalSummary.vue?vue&type=template&id=801a4378&scoped=true"
import script from "./BillTotalSummary.vue?vue&type=script&lang=js"
export * from "./BillTotalSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801a4378",
  null
  
)

export default component.exports